<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :showFooter="false"
    :hasInstructions="instruction.display"
    :instructionPictures="instruction.pictures"
    :instructionText="instruction.text"
    :instructionTitle="instruction.title"
  >
    <v-radio-group v-model="selected">
      <v-sheet outlined rounded :color="activeCardStyle(item)" v-for="(item, i) in items" :key="i" class="mb-2 py-n6">
        <v-card flat @click="selected = item">
          <v-list three-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(`report.thgPayoutOptionSelector.options.${item}.title`) }}
                  <v-chip v-if="item === 'regular'" color="success" outlined small>
                    {{ $t("report.thgProducts.popular") }}
                  </v-chip>
                  <v-chip v-if="item === 'express'" color="success" small>
                    {{ $t("report.thgProducts.new") }}
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $t(`report.thgPayoutOptionSelector.options.${item}.subtitle`) }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-radio :value="item"></v-radio>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-sheet>
    </v-radio-group>
    <v-subheader>{{ $t("report.thgPayoutOptionSelector.hint") }}</v-subheader>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { Component } from "vue-property-decorator";
import ThgImpactSelectorCard from "./ThgImpactSelectorCard.vue";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { PayoutOptionEnum } from "./enum/payout-option.enum";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";

@Component({
  components: {
    LayoutReportStep,
    ThgImpactSelectorCard
  }
})
export default class ThgPayoutOptionSelector extends ReportStepMixin implements IReportStep {
  public header: IReportHeaderData = {
    title: "report.thgPayoutOptionSelector.title",
    description: "report.thgPayoutOptionSelector.description"
  };
  screen = ReportScreenEnum.thgpayoutoptionselector;

  public instruction: IReportInstructionData = {
    title: "report.thgPayoutOptionSelector.instructionTitle",
    text: "report.thgPayoutOptionSelector.instructionText",
    pictures: [],
    example: undefined,
    display: false
  };

  get isDone() {
    return true;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  activeCardStyle(option: PayoutOptionEnum) {
    if (this.selected === option) {
      return "primary";
    }
    return "";
  }

  get items() {
    return ThgCreateModule.activePayoutOptions;
  }

  get selected() {
    return ThgCreateModule.payoutOption;
  }

  set selected(option: PayoutOptionEnum) {
    ThgCreateModule.setPayoutOption(option);
  }

  mounted() {
    this.setCurrentStep();
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
